// extracted by mini-css-extract-plugin
module.exports = {"detalls":"detalls_detalls__QorWd","gapAfter":"detalls_gapAfter___hW9R"};